import { ROLES, checkPermissionExistence, userPermission } from "./index";

const PROFILE_TYPES = ["Basic", "Free", "Paid"];

const onlyPlayer = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[0];
};

const exceptPlayer = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[0]);
  return roles.includes(userPermission());
};

const onlyBasicPlayer = () => {
  return onlyPlayer() && localStorage["profile-type"] === PROFILE_TYPES[0];
};

const exceptBasicPlayer = () => {
  checkPermissionExistence();
  return localStorage["profile-type"] !== PROFILE_TYPES[0];
};

const onlyFreePlayer = () => {
  return onlyPlayer() && localStorage["profile-type"] === PROFILE_TYPES[1];
};

const exceptFreePlayer = () => {
  checkPermissionExistence();
  return localStorage["profile-type"] !== PROFILE_TYPES[1];
};

const onlyPaidPlayer = () => {
  return onlyPlayer() && localStorage["profile-type"] === PROFILE_TYPES[2];
};

const exceptPaidPlayer = () => {
  checkPermissionExistence();
  return localStorage["profile-type"] !== PROFILE_TYPES[2];
};

export default {
  onlyPlayer,
  exceptPlayer,
  onlyBasicPlayer,
  exceptBasicPlayer,
  onlyFreePlayer,
  exceptFreePlayer,
  onlyPaidPlayer,
  exceptPaidPlayer
};
